(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelector(".thb-secondary-area-item.thb-quick-search")?.addEventListener("click", (event) => {
      	document.querySelector('#side-panel-search-input')?.focus();
  	});
  } catch(e) { console.error(e); }
})();

})();
